import React, { useContext, useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  getContratosList,
  getContactoLocal,
} from "./components/getDataContratos";
import setRedirectUrl from "../../redux/actions/redirection/setRedirectUrl";
import setLogged from "../../redux/actions/logged/setLogged";
import Navbar from "../../components/Navbar";
import DisplayContractsDesktop from "./components/Desktop/renderContractsDesktop";
import DisplayContractsMobile from "./components/Mobile/renderContractsMobile";
import { useTheme, useMediaQuery } from "@mui/material";
import NoContractsLabel from "./components/noContractsLabel";
import Loading from "../../components/Common/Loading";
import Footer from "../Home/components/Footer";
import { TenantsContext } from "../../context/tenants.context";

const ContratosVendedor: React.FC = (props: any) => {
  const { userLogged } = props.logged;
  const { idLocal } = userLogged;
  const [contratosList, setContratosList] = useState<any[]>([]);
  const [contactoLocal, setContactoLocal] = useState<any>("");
  const [loading, setLoading] = useState<boolean>(false);
  const { tenant } = useContext(TenantsContext);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    const fetchContratos = async () => {
      try {
        setLoading(true);
        const contratosData = await getContratosList(idLocal);
        setContratosList(contratosData);
        const contactoLocal = await getContactoLocal(idLocal, tenant);
        setContactoLocal(contactoLocal);
      } catch (error) {
        console.error("Error fetching contratos:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchContratos();
  }, [idLocal]);

  if (loading) return <Loading />;
  return (
    <>
      <Navbar title="Suscripciones" />
      {contratosList.length > 0 ? (
        isMobile ? (
          <DisplayContractsMobile
            contratosList={contratosList}
            contactoLocal={contactoLocal}
          />
        ) : (
          <DisplayContractsDesktop
            contratosList={contratosList}
            contactoLocal={contactoLocal}
          />
        )
      ) : (
        <NoContractsLabel message="No tienes suscripciones"></NoContractsLabel>
      )}

      <div
        style={{
          position: contratosList.length < 5 ? "fixed" : "relative",
          width: "100%",
          bottom: 0,
        }}
      >
        <Footer />
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    logged: state.logged,
    theme: state.theme,
    toaster: state.toaster,
    redirection: state.redirection,
  };
};

const mapDispatchToProps = {
  setRedirectUrl,
  setLogged,
};

export default connect(mapStateToProps, mapDispatchToProps)(ContratosVendedor);
